export const enCommon = {
  "language.menu": "Select language",
  "language.english": "English",
  "language.chinese": "简体中文",
  "meta.title": "OURS — Community-owned meme launchpad",
  "meta.description": "OURS community-owned meme launchpad on Robinhood Chain",
  "common.loading": "OURS / LOADING",
  "toast.region": "Notifications",
  "toast.dismiss": "Dismiss notification",
  "toast.info": "Info",
  "toast.success": "Success",
  "toast.warning": "Warning",
  "toast.error": "Failed",
  "toast.loading": "Processing",
  "toast.copyFailed": "Could not copy to the clipboard. Please try again.",
  "update.available": "A new version is available",
  "update.description":
    "Finish your current task, then refresh to use the latest version.",
  "update.refresh": "Refresh page",
  "update.dismiss": "Dismiss update notice",
  "error.notFoundEyebrow": "404 / OURS",
  "error.notFoundTitle": "This page has not launched yet.",
  "error.notFoundDescription":
    "Return to the Token market and keep discovering new projects on Robinhood Chain.",
  "error.backToExplore": "Back to Explore",
  "error.oursHome": "Back to OURS home",
  "error.systemStatus": "System status",
  "error.unexpectedEyebrow": "{{status}} / TEMPORARILY OFFLINE",
  "error.unexpectedTitle": "This page went off-script.",
  "error.unexpectedDescription":
    "You did nothing wrong. We could not finish loading this page. Try again, or head back to Explore and keep browsing.",
  "error.tryAgain": "Try again",
  "error.statusCode": "Error status code {{status}}",
  "error.reference": "Reference",
  "error.time": "Time",
  "error.technicalDetails": "Technical details",
  "error.copyDetails": "Copy diagnostics",
  "error.copied": "Copied",
  "error.copyFailed": "Copying failed. Select the details above to copy them.",
  "error.supportHint":
    "If this keeps happening, share reference {{reference}} with support.",
} as const;
